import { render, staticRenderFns } from "./MobileHeaderIcon.vue?vue&type=template&id=4f8f633d&scoped=true"
import script from "./MobileHeaderIcon.vue?vue&type=script&lang=js"
export * from "./MobileHeaderIcon.vue?vue&type=script&lang=js"
import style0 from "./MobileHeaderIcon.vue?vue&type=style&index=0&id=4f8f633d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8f633d",
  null
  
)

export default component.exports